// FAQ + Akkordeons + Karten-Toggle (vanilla JS, ersetzt jQuery-Version)
// WICHTIG: Antwort-Container stehen per CSS auf display:none — slideDown MUSS display setzen.
(function () {
  function slideUp(el) {
    clearTimeout(el._faqTimer);
    el.style.overflow = 'hidden';
    el.style.transition = 'max-height 0.25s ease';
    el.style.maxHeight = '0';
    el._faqTimer = setTimeout(function () { el.style.display = 'none'; }, 260);
  }
  function slideDown(el) {
    clearTimeout(el._faqTimer);
    el.style.display = 'block';
    el.style.overflow = 'hidden';
    el.style.transition = 'max-height 0.25s ease';
    el.style.maxHeight = '0';
    requestAnimationFrame(function () {
      el.style.maxHeight = el.scrollHeight + 'px';
    });
    setTimeout(function () { el.style.maxHeight = 'none'; }, 300);
  }

  document.addEventListener('click', function (e) {
    // FAQ-Sektion
    var faqQ = e.target.closest('.faq-section-block-question');
    if (faqQ) {
      var block = faqQ.closest('.faq-section-main-block');
      var wrapper = faqQ.closest('.media_faq_wrapper');
      var wasActive = block.classList.contains('active');
      if (wrapper) {
        wrapper.querySelectorAll('.faq-section-main-block').forEach(function (b) {
          b.classList.remove('active');
          if (b !== block || wasActive) {
            b.querySelectorAll('.faq-section-block-answer').forEach(slideUp);
          }
        });
      }
      if (!wasActive) {
        block.classList.add('active');
        block.querySelectorAll('.faq-section-block-answer').forEach(slideDown);
      }
      return;
    }

    // Produkt-Akkordeon
    var accQ = e.target.closest('.product-acc-question');
    if (accQ) {
      var item = accQ.closest('.product-acc-item');
      var active = item.classList.contains('active');
      item.classList.toggle('active', !active);
      item.querySelectorAll('.product-acc-answer').forEach(active ? slideUp : slideDown);
      return;
    }

    // Green-Helpers-Karten
    var ghBtn = e.target.closest('.green-helpers-button');
    if (ghBtn) {
      e.preventDefault();
      var card = ghBtn.closest('.green-helpers-card');
      var isActive = card && card.classList.contains('active');
      document.querySelectorAll('.green-helpers-card').forEach(function (c) {
        c.classList.remove('active');
      });
      if (card && !isActive) card.classList.add('active');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var first = document.querySelector('.product-acc-item:first-child');
    if (first) first.classList.remove('active');
    // Bereits aktive Elemente initial sichtbar machen
    document.querySelectorAll('.product-acc-item.active .product-acc-answer, .faq-section-main-block.active .faq-section-block-answer').forEach(function (el) {
      el.style.display = 'block';
      el.style.maxHeight = 'none';
    });
  });
})();
